export const catalogKeys = {
  all: ['catalog'],
  products: () => [...catalogKeys.all, 'products'],
  productList: (params) => [...catalogKeys.products(), 'list', params],
  featured: () => [...catalogKeys.products(), 'featured'],
  product: (slug) => [...catalogKeys.products(), 'detail', slug],
  categories: () => [...catalogKeys.all, 'categories'],
  testimonials: () => [...catalogKeys.all, 'testimonials'],
  storeInfo: () => [...catalogKeys.all, 'store-info'],
  reviews: (slug) => [...catalogKeys.product(slug), 'reviews'],
  // Deliberately not under `all` — invalidating the catalog must not
  // invalidate the poll that detects catalog changes.
  version: () => ['catalog-version'],
};
